export default __webpack_public_path__ + "static/media/227.33e49ea3.png";